module.exports = __webpack_public_path__ + "img/logo-white.48e4f37e.png";